<div class="executions-list">
    <div class="table-actions">
        <app-executions-filters class="actions" [pageFilters]="pageFilters"></app-executions-filters>
    </div>

    <div class="table-header">
        <div class="items-amount" *ngIf="totalItems > -1">
            {{ "common.found" | labelsProvider }} {{ totalItems | number }}
            {{ "zenityCommon.playbooks" | labelsProvider | lowercase }}
            {{ "playbooks.executions" | labelsProvider | lowercase }}
        </div>

        <div class="table-header-right">
            <app-columns-selection
                class="columns-selection"
                [columns]="columns()"
                [pageName]="pageName"
                (columnsSelected)="columnsSelected($event)" />
        </div>
    </div>

    <div class="table">
        <app-prime-table
            class="table-component"
            #table
            queryParamProperty="resource"
            [data$]="currentPage$"
            [rowsPerPage]="defaultPageSize"
            [columns]="columns()"
            [isLoading]="(isLoading$ | async) === true"
            [withCheckboxSelection]="false"
            [sortedColumn$]="pageFilters.sortedColumn$"
            [pageInfo]="pageInfo$.value"
            (pageOnChange)="onPagination($event)"
            [withActions]="false"
            [withRowSelection]="false"
            tableNotFoundText="You don't have any resources"
            tableNotFoundIcon="assets/images/common/no-results-found.svg"
        />
    </div>
</div>
